import { Scalings } from "./settings/Scalings.js";
import { CopyReference } from "./actions/CopyReference.js";
import { MoveUp } from "./actions/MoveUp.js";
import { ToggleTheme } from "./actions/ToggleTheme.js";

Scalings.use();
ToggleTheme.use();
CopyReference.use();
MoveUp.use();
